import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveExit20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMoveExit20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M12.173 8.031c0 .414.336.75.75.75h4.847a.75.75 0 0 0 0-1.5h-4.847a.75.75 0 0 0-.75.75m.134 3.007c0 .414.335.75.75.75h3.297a.75.75 0 0 0 0-1.5h-3.297a.75.75 0 0 0-.75.75M1.653 9.625a4.626 4.626 0 1 0 9.252 0 4.626 4.626 0 0 0-9.252 0m1.5 0a3.126 3.126 0 1 1 6.252 0 3.126 3.126 0 0 1-6.252 0"
            />
        </svg>
    );
}
export default memo(IconMoveExit20);
